import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Link from "next/link";
import Image from "next/image";

import carouselBGimg01 from "../../assets/images/home/Banner/UPSC-result-web-banner-2026.jpg";
import carouselBGimg02 from "../../assets/images/home/Banner/Prestorming-Web-Banner-B3-Click-Here.jpg";
// import carouselBGimg03 from "../../assets/images/home/Banner/TNPSC-Group-II-and-IIa-Mock-test-Web-Banner-Click-Here.jpg";
import carouselBGimg04 from "../../assets/images/home/Banner/TNPSC-GR-I-Admission-Open-Web-Banner-Click-Here.jpg";
import carouselBGimg05 from "../../assets/images/home/Banner/upsc-Mentorship-Programme-Web-Banner-click-here.jpg";
import carouselBGimg06 from "../../assets/images/home/Banner/Sadhana-Web-Banner-2026.jpg";
import carouselBGimg07 from "../../assets/images/home/Banner/Academy-International-Relations-Web-Banner.jpg";


import carouselBGimg5 from "../../assets/images/home/Banner/UPSC-GSPCM-Web-Banner-with-button-26.jpg";
import carouselBGimg6 from "../../assets/images/home/Banner/TNPSC-RESULT-Web-Banner-2025.jpg";
import carouselBGimg7 from "../../assets/images/home/Banner/TNPSC-Gr1-Mains-Crash-Course-Web-Banner-Click-Here.jpg";
import carouselBGimg8 from "../../assets/images/home/Banner/Felicitation -web-banner-button.jpg";
import carouselBGimg9 from "../../assets/images/home/Banner/Forest-Result-2025-Web-Banner.jpg";
import carouselBGimg10 from "../../assets/images/home/Banner/Upsc-Interview-webbanner-2026-Click-Here.jpg";

// import carouselBGimg13 from "../../assets/images/home/Banner/Moksha-Web-Banner-Click-Here.jpg";


{/* mobile */}
import carouselMBimg01 from "../../assets/images/home/Mob_Banner/UPSC-result-mobile-banner-2026.jpg";
import carouselMBimg02 from "../../assets/images/home/Mob_Banner/Prestorming-Mob-Banner-B3-Click-Here.jpg";
import carouselMBimg03 from "../../assets/images/home/Mob_Banner/Upsc-Interview-Mobbanner-2026-Click-Here.jpg";
// import carouselMBimg04 from "../../assets/images/home/Mob_Banner/TNPSC-Group-II-and-IIa-Mock-test-Mobile-Banner-Click-Here.jpg";
import carouselMBimg05 from "../../assets/images/home/Mob_Banner/upsc-Mentorship-Programme-Mob-Banner-click-here.jpg";
import carouselMBimg06 from "../../assets/images/home/Mob_Banner/Sadhana-Mobile-Banner-2026.jpg";
import carouselMBimg07 from "../../assets/images/home/Mob_Banner/UPSC-GSPCM-Mobbanner-Clickhere-26.jpg";


import carouselMBimg6 from "../../assets/images/home/Mob_Banner/TNPSC-RESULT-Mobile-Banner-2025.jpg";
import carouselMBimg7 from "../../assets/images/home/Mob_Banner/UPSC-GSPCM-Mobbanner-Clickhere-26.jpg";
import carouselMBimg8 from "../../assets/images/home/Mob_Banner/Felicitation-Mob-banner-button.jpg";
import carouselMBimg9 from "../../assets/images/home/Mob_Banner/Forest-Result-2025-Mobile-Banner.jpg";
import carouselMBimg10 from "../../assets/images/home/Mob_Banner/TNPSC-GR-I-Admission-Open-Mobile-Banner-Click-Here.jpg";
import carouselMBimg12 from "../../assets/images/home/Mob_Banner/TNPSC-Gr1-Mains-Crash-Course-Mob-Banner-Click-Here.jpg";
// import carouselMBimg13 from "../../assets/images/home/Mob_Banner/Moksha-Mobile-Banner-Click-here.jpg";




function slider() {

    const BGimg = [
      { quickLoading: false, img: carouselBGimg06, alt: "carousel",link: "/two-year-upsc-program/" },
      { quickLoading: false, img: carouselBGimg01, alt: "carousel",link: "/upsc-admission-anna-nagar" },
      { quickLoading: false, img: carouselBGimg5,  alt: "carousel",link: "/upsc-admission-anna-nagar/#pregspcm" },
      { quickLoading: false, img: carouselBGimg05, alt: "carousel",link: "/upsc-mentorship-programme" },
      // { quickLoading: false, img: carouselBGimg03, alt: "carousel",link: "/tnpsc-group-II-IIA-prelims-mock-test/" },
      { quickLoading: false, img: carouselBGimg7,  alt: "carousel",link: "/tnpsc-group-i-mains-crash-course/" },
    
      { quickLoading: false, img: carouselBGimg07, alt: "carousel",link: "/academy-for-international-relations" },
      
      { quickLoading: false, img: carouselBGimg02, alt: "carousel",link: "/upsc-prestorming-prelims-test-series" },
      { quickLoading: false, img: carouselBGimg10, alt: "carousel",link: "/upsc-interview/" },
      { quickLoading: false, img: carouselBGimg04, alt: "carousel",link: "/tnpsc-admissions" },
      { quickLoading: false, img: carouselBGimg6, alt: "carousel", link: "/tnpsc-admissions" },
      { quickLoading: false, img: carouselBGimg8,  alt: "carousel", link: "https://www.shankariasacademy.com/blog/felicitation-of-2024-achievers/" },
      { quickLoading: false, img: carouselBGimg9,  alt: "carousel", link: "/upsc-admission-anna-nagar" },
      // { quickLoading: false, img: carouselBGimg13, alt: "carousel", link: "/upsc-mains-test-series" },

      
       ]

      const MBimg = [
         { quickLoading: false, img: carouselMBimg06, alt: "carousel", link: "/two-year-upsc-program/" },
        { quickLoading: false, img: carouselMBimg01, alt: "carousel", link: "/upsc-admission-anna-nagar" },
        { quickLoading: false, img: carouselMBimg6, alt:  "carousel", link: "/tnpsc-admissions" },
        { quickLoading: false, img: carouselMBimg12, alt: "carousel", link: "/tnpsc-group-i-mains-crash-course" },
        { quickLoading: false, img: carouselMBimg05, alt: "carousel", link: "/upsc-mentorship-programme" },
        // { quickLoading: false, img: carouselMBimg04, alt: "carousel", link: "/tnpsc-group-II-IIA-prelims-mock-test/" },  
       
        { quickLoading: false, img: carouselMBimg07, alt: "carousel", link: "/academy-for-international-relations" },
        { quickLoading: false, img: carouselMBimg02, alt: "carousel", link: "/upsc-prestorming-prelims-test-series" },
        { quickLoading: false, img: carouselMBimg03, alt: "carousel", link: "/upsc-interview" },
        // { quickLoading: false, img: carouselMBimg13, alt: "carousel", link: "/upsc-mains-test-series" },
        { quickLoading: false, img: carouselMBimg8, alt: "carousel", link: "https://www.shankariasacademy.com/blog/felicitation-of-2024-achievers/" },
        { quickLoading: false, img: carouselMBimg7, alt: "carousel", link: "/tnpsc-admissions" },
        { quickLoading: false, img: carouselMBimg9, alt: "carousel", link: "/upsc-admission-anna-nagar" },
        { quickLoading: false, img: carouselMBimg10, alt: "carousel", link: "/tnpsc-admissions" },

      ]
  
  return (
    <>
        {/* Carousel large devices*/}
      <div className="container-fluid">
        <div className="row">
          <div className="col px-0 d-none d-md-block">
            <Carousel>
              {BGimg.map((e, index) =>
                <Carousel.Item
                      key={index}
                      interval={e.img === carouselBGimg06 ? 10000 : 3000}
                    >
                      <Link href={e.link} rel="noreferrer">
                        <Image
                          className="carouselimage img-fluid w-100 h-100"
                          src={e.img}
                          alt={e.alt}
                          title="Shankar IAS Academy"
                          loading={e.quickLoading ? "eager" : "lazy"}
                          placeholder="blur"
                        />
                      </Link>
                    </Carousel.Item>
              )}
            </Carousel>
          </div>
        </div>
      </div>

      {/* Carousel Mobile devices*/}
      <div className="container-fluid">
        <div className="row">
          <div className="col px-0 d-block d-md-none">
            <Carousel>
              {MBimg.map((e, index) =>
                <Carousel.Item 
                key={index}
                interval={e.img === carouselBGimg06 ? 10000 : 3000}
                >
                  <Link href={e.link} rel="noreferrer">
                    <Image
                      className="carouselimage img-fluid"
                      src={e.img}
                      alt={e.alt}
                      title="Shankar IAS Academy"
                      loading={e.quickLoading ? "eager" : "lazy"}
                      placeholder="blur"
                    /></Link>
                </Carousel.Item>
              )}
            </Carousel>
          </div>
        </div>
      </div>

    </>
  )
}

export default slider